import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import parse from 'html-react-parser';
import UpdateReviewer from './UpdateReviewer';

function ReviewersDash({ showMessage, title_page }) {
    useEffect(() => {
        document.title = title_page;
    }, [title_page]);

    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState("view");
    const [title, setTitle] = useState("");
    const [currentReviewerId, setCurrentReviewerId] = useState("");
    const [reviewers, setReviewers] = useState([]);
    const [showUpdate, setShowUpdate] = useState(false);

    const itemsPerPage = 10;
    const [currentPage, setCurrentPage] = useState(1);

    const tabActivated = (tabName) => {
        navigate(`?tab=${tabName}`);
        if (tabName === "view") {
            setActiveTab("view");
            setShowUpdate(false);
        } else {
            setActiveTab("create");
        }
    };

    const submitReviewer = async () => {
        if (!title) {
            showMessage("error", "Title is required.");
            return;
        }

        const formData = new FormData();
        formData.append('title', title);

        try {
            const response = await fetch('https://annalsofnursing.org/aon_backend/api/api.php?action=submitReviewer', {
                method: 'POST',
                credentials: "include",
                body: formData,
            });

            const data = await response.json();
            if (data.success) {
                showMessage("success", "Reviewer added successfully!");
                reloadForm();
                fetchReviewers();
                tabActivated("view");
            } else {
                showMessage("error", data.error || "Submission failed.");
            }
        } catch (err) {
            showMessage("error", err);
        }
    };

    const reloadForm = () => {
        setTitle("");
    };

    const fetchReviewers = () => {
        fetch("https://annalsofnursing.org/aon_backend/api/api.php?action=getAllReviewers")
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    setReviewers(data.reviewers);
                } else {
                    console.error("API Error:", data.error);
                }
            })
            .catch(error => console.error("Error fetching reviewers:", error));
    };

    useEffect(() => {
        // Check session
        fetch('https://annalsofnursing.org/aon_backend/api/api.php?action=checkUserSession', {
            method: 'GET',
            credentials: "include",
        })
            .then(response => response.json())
            .then(data => {
                if (data.success !== 'true') {
                    navigate("/dashboard/login");
                }
            })
            .catch(error => console.log(error));

        fetchReviewers();
    }, []);

    const dashLogout = () => {
        fetch('https://annalsofnursing.org/aon_backend/api/api.php?action=removeUserSession', {
            method: 'GET',
            credentials: "include",
        })
            .then(response => response.json())
            .then(data => {
                if (data.success === 'true') {
                    showMessage("success", "Logged Out!");
                    navigate("/dashboard/login");
                }
            })
            .catch(() => {
                showMessage("error", "Something went wrong.");
            });
    };

    const deleteReviewer = async (reviewerId) => {
        const confirmed = window.confirm("Are you sure you want to delete this reviewer?");
        if (!confirmed) return;

        try {
            const response = await fetch(`https://annalsofnursing.org/aon_backend/api/api.php?action=deleteReviewer`, {
                method: 'POST',
                credentials: "include",
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ id: reviewerId }),
            });

            const data = await response.json();

            if (data.success) {
                showMessage("success", "Reviewer deleted successfully.");
                fetchReviewers();
            } else {
                showMessage("error", data.error);
            }
        } catch (err) {
            showMessage("error", err.message);
        }
    };

    const updateReviewer = (reviewerId) => {
        setCurrentReviewerId(reviewerId);
        setShowUpdate(true);
    };

    const dashBack = () => {
        navigate("/dashboard");
    };

    // Pagination
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = reviewers.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(reviewers.length / itemsPerPage);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    return (
        <div className='dash_section'>
            <div className="dash_wrapper">

                <div className='dash_logout'>
                    <div className='dash_back_cta' onClick={dashBack}>
                        Dashboard
                    </div>
                    <div className='dash_logout_cta' onClick={dashLogout}>
                        Logout
                    </div>
                </div>

                <div className='dash_header_tabs'>
                    <div className='dash_header_tab' onClick={() => tabActivated('view')} style={activeTab === "view" ? { borderBottom: '2px solid gray' } : {}}>
                        View Reviewers
                    </div>
                    <div className='dash_header_tab' onClick={() => tabActivated('create')} style={activeTab === "create" ? { borderBottom: '2px solid gray' } : {}}>
                        Add New Reviewer
                    </div>
                </div>

                {/* View Reviewers */}
                <div className='dash_body_tab' style={activeTab === "view" ? { display: 'block' } : { display: 'none' }}>
                    {!showUpdate ? (
                        <div>
                            <h2 className='dash_body_title'>Reviewers - View</h2>
                            <div className='dash_table_wrapper'>
                                <div className='dash_table_body'>
                                    {currentItems.map((reviewer) => (
                                        <div key={reviewer.id} className='dash_table_body_wrapper'>
                                            <p><strong>ID:</strong> {reviewer.id}</p>
                                            <br/><br/>
                                            <p className='dash_table_info_title'>{parse(reviewer.title)}</p>
                                            <br/><br/>
                                            <div className='dash_table_info_actions'>
                                                <button className='dash_table_info_action' onClick={() => updateReviewer(reviewer.id)}>Update</button>
                                                <button className='dash_table_info_action info_action_delete' onClick={() => deleteReviewer(reviewer.id)}>Delete</button>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* Pagination */}
                            <div style={{ marginTop: "1rem", textAlign: "center", display: "flex", justifyContent: "center", alignItems: "center", gap: "1rem" }}>
                                <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>←</button>
                                <span>Page {currentPage} of {totalPages}</span>
                                <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>→</button>
                            </div>
                        </div>
                    ) : (
                        <>
                            <h2 className='dash_body_title'>Reviewers - Update</h2>
                            <UpdateReviewer id={currentReviewerId} showMessage={showMessage} setShowUpdate={setShowUpdate} fetchReviewers={fetchReviewers} />
                        </>
                    )}
                </div>

                {/* Create Reviewer */}
                <div className='dash_body_tab' style={activeTab === "create" ? { display: 'block' } : { display: 'none' }}>
                    <h2 className='dash_body_title'>Add New Reviewer</h2>
                    <div className='dash_update_records'>
                        <label>1. Title</label><br />
                        <input className='dash_input' type="text" value={title} onChange={(e) => setTitle(e.target.value)} /><br />
                        <div className='dash_buttons_wrapper'>
                            <button className='dash_form_buttom' onClick={submitReviewer}>Submit</button>
                            <button className='dash_form_buttom dash_reset' onClick={reloadForm}>Reset</button>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default ReviewersDash;
